module.exports = __webpack_public_path__ + "static/media/trust_icon_registration.1ff5da2f.svg";